import React, { useEffect, useState } from "react";
import quraan from "../../../Assets/Images/quraan.png";
import porfolio from "../../../Assets/Images/portfolio.png";
import realestate from "../../../Assets/Images/realestate.png";
import stopwatch from "../../../Assets/Images/stopwatch.png";

const availableProjects = [
  {
    id: "p2",
    name: "Real Estate App",
    about:
      "A Real estate WebApp that list properties in States in Nigeria; states like Lagos, Abuja and Kano. It gives the option to search by filter. it also gives the user two modes of view, the dark mode and the light mode.It also gives the user an option to upload a new property to the page. ",
    src: realestate,
    tools: "CSS,REACT.",
    href: "https://moyoproperties.netlify.app/",
  },
  {
    id: "p4",
    name: "Race Timer",
    about:
      "A Race timer that records the ruun times and ad send it to the leaderboard table in real-time via a firebase database",
    src: stopwatch,
    tools: "REACT,SWIPER.JS,Firebase.",
    href: "https://stopwatch-moyo.netlify.app/",
  },
  {
    id: "p3",
    name: "Quraan Indexer",
    about:
      "An Indexer that makes calls to a REST API to get the results of the search made by the user in the Quran(the muslim Holy book) it returns four results for each search: The arabic text, the Translation, the audio recording and the more-info modal. It also uses cookies to generate a custom greeting for the user.",
    src: quraan,
    tools: "ES6, HTML, CSS.",
    href: "https://moyosoreeo.github.io/Quraan-Indexer/",
  },
  {
    id: "p1",
    name: "Portfolio",
    about:
      "My portfolio website made with React and CSS modules, it features my recent projects, skills and a contact me section. Also attached is a copy of my resume",
    src: porfolio,
    tools: "React, CSS-modules",
    href: "https://moyo-lao.netlify.app",
  },
];
const UtilityContext = React.createContext({
  project: [],
  openedProject: {},
  menuIsOpen: false,
  openMenuHandler: () => {},
  closeMenuHandler: () => {},
  modalIsOpen: false,
  closeModalHandler: () => {},
  openModalHandler: () => {},
  skill: {},
  skillIsOpen: false,
  openSkillModal: () => {},
  closeSkillModal: () => {},
  screenWidth: 0,
  moreInfoItem: {},
  moreInfoIsOpen: false,
  openMoreInfoHandler: () => {},
  closeMoreInfoHandler: () => {},
});

export const UtilityContextProvider = (props) => {
  //calculate Width prop
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.addEventListener("resize", () => {
      const id = setTimeout(() => {
        setScreenWidth(window.innerWidth);
      }, 500);
      return () => {
        clearTimeout(id);
      };
    });
  }, []);
  const [projects, setProjects] = useState(availableProjects);
  const [openedProject, setOpenedProject] = useState({});
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  //Project-modal logics
  const openModalHandler = (project) => {
    document.body.style.overflow = "hidden";
    setOpenedProject(project);
    setModalIsOpen(true);
    setProjects((prev) => {
      const newProject = prev.filter((item) => {
        return item.id !== project.id;
      });
      return newProject;
    });
  };
  const closeModalHandler = () => {
    document.body.style.overflow = "";
    setModalIsOpen(false);
    setProjects(availableProjects);
    setOpenedProject({});
  };
  //Skill-modal logic
  const [skill, setSkill] = useState({});
  const [skillIsOpen, setSkillIsOpen] = useState(false);
  document.onload = () => {
    if (screenWidth > 768) {
      setSkillIsOpen(true);
    }
  };
  const openSkillModal = (item) => {
    document.body.style.overflow = "hidden";
    setSkill(item);
    setSkillIsOpen(true);
  };
  const closeSkillModal = () => {
    document.body.style.overflow = "";
    setSkillIsOpen(false);
    setSkill({});
  };

  //skill-moreInfo Logic
  const [moreInfoIsOpen, setMoreInfo] = useState(false);
  const [moreInfoItem, setMoreInfoItem] = useState({});
  const openMoreInfoHandler = (item) => {
    setMoreInfo(true);
    setMoreInfoItem(item);
  };
  const closeMoreInfoHandler = () => {
    setMoreInfo(false);
  };

  //menu logics
  const openMenuHandler = () => {
    if (menuIsOpen === true) {
      document.body.style.overflow = "scroll";
      setMenuIsOpen(false);
    } else {
      document.body.style.overflow = "hidden";
      setMenuIsOpen(true);
    }
  };
  const closeMenuHandler = () => {
    document.body.style.overflow = "scroll";
    setMenuIsOpen(false);
  };

  return (
    <UtilityContext.Provider
      value={{
        screenWidth: screenWidth,
        project: projects,
        openedProject: openedProject,
        menuIsOpen: menuIsOpen,
        openMenuHandler: openMenuHandler,
        closeMenuHandler: closeMenuHandler,
        modalIsOpen: modalIsOpen,
        openModalHandler: openModalHandler,
        closeModalHandler: closeModalHandler,
        skill: skill,
        skillIsOpen: skillIsOpen,
        openSkillModal: openSkillModal,
        closeSkillModal: closeSkillModal,
        moreInfoItem: moreInfoItem,
        openMoreInfoHandler: openMoreInfoHandler,
        closeMoreInfoHandler: closeMoreInfoHandler,
        moreInfoIsOpen: moreInfoIsOpen,
      }}
    >
      {props.children}
    </UtilityContext.Provider>
  );
};

export default UtilityContext;
